/** The StrategyLab mark (a hexagon with a rising staircase), with "Hive" in the brand gold. */
const HEX_PATH = "M16 3 L27.26 9.5 L27.26 22.5 L16 29 L4.74 22.5 L4.74 9.5 Z";

export function Logo({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true" focusable="false">
      <path d={HEX_PATH} fill="var(--logo-amber, #ffc107)" />
      <rect x="10.2" y="16" width="3" height="8" rx="1.3" fill="#14110a" />
      <rect x="14.5" y="12" width="3" height="12" rx="1.3" fill="#14110a" />
      <rect x="18.8" y="7.5" width="3" height="16.5" rx="1.3" fill="#14110a" />
    </svg>
  );
}

export function Wordmark({ size = 22 }: { size?: number }) {
  return (
    <span className="wordmark">
      <Logo size={size} />
      <span className="wordmark-text" style={{ fontSize: size * 0.72 }}>
        Strategy<span className="wordmark-hub">Hive</span>
      </span>
    </span>
  );
}
